import styled from "styled-components";

export const CalloutContainer = styled.div(({ theme }) => `
    background-color: ${theme.accent2Color};
    color: white;
    padding: 1rem;
    border-radius: 0.5rem;
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: center;

    // in slideshow, the callout must have higher z-index to be visible
    // and be centered on the screen
    &[data-route-key*="slideshow"] {
        position: fixed;
        z-index: 10000;
        min-width: 70%;
        left: 50%;
        transform: translate(-50%, 0);
        top: 0;
    }
`)